import { Outlet } from 'react-router-dom';
import { Activity, Building2, Bug, Receipt, Server } from 'lucide-react';
import { BottomNav, TabFrame, type NavItem } from '@/components/layout';

/**
 * 시스템 관리자 콘솔 셸 (§3.2) — 관제 / 기관 / 정산 / 에러 / 시스템.
 * 학부모·교직원 앱과 같은 프레임을 쓰되 탭 구성만 운영 업무에 맞춘다.
 */
export function AdminShell() {
  const items: NavItem[] = [
    { to: '/', label: '관제', icon: <Activity size={20} />, end: true },
    { to: '/facilities', label: '기관', icon: <Building2 size={20} /> },
    { to: '/billing', label: '정산', icon: <Receipt size={20} /> },
    { to: '/errors', label: '에러', icon: <Bug size={20} /> },
    { to: '/system', label: '시스템', icon: <Server size={20} /> },
  ];

  return (
    <TabFrame nav={<BottomNav items={items} />}>
      <Outlet />
    </TabFrame>
  );
}
